import React, { useEffect } from "react";
import { useBottomTabs } from "@/context/BottomTabsContext";
import FoodTabs from "@/components/lheader/components/BottomTabs";
import { useRouter } from "next/router";

const BottomTabsContainer: React.FC = () => {
  const { tabs, selectedTabId, setSelectedTabId, setTabs } = useBottomTabs();
  const router = useRouter();

  // Clear tabs on route change
  useEffect(() => {
    // Function to clear tabs
    const clearTabs = () => {
      setTabs([]);
      setSelectedTabId(null);
    };

    // Set up route change listener
    router.events.on("routeChangeStart", clearTabs);

    // Clean up
    return () => {
      router.events.off("routeChangeStart", clearTabs);
    };
  }, [router.events, setTabs, setSelectedTabId]);

  // Add/remove class to header when tabs visibility changes
  useEffect(() => {
    const headerEl = document.querySelector(".header-component");
    if (headerEl) {
      if (tabs && tabs.length > 0) {
        headerEl.classList.add("has-tabs");
      } else {
        headerEl.classList.remove("has-tabs");
      }
    }

    return () => {
      // Clean up when component unmounts
      const headerEl = document.querySelector(".header-component");
      if (headerEl) {
        headerEl.classList.remove("has-tabs");
      }
    };
  }, [tabs]);

  if (!tabs || tabs.length === 0) {
    return null;
  }

  const handleTabChange = (tabId: string | null) => {
    setSelectedTabId(tabId);

    if (!tabId) return;

    const tabEl = document.querySelector(`[data-tab-id="${tabId}"]`);
    if (tabEl) {
      const rect = tabEl.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      const offsetPosition = scrollTop + rect.top - 120;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <FoodTabs
      tabs={tabs}
      defaultSelected={selectedTabId}
      onTabChange={handleTabChange}
    />
  );
};

export default BottomTabsContainer;
